import React, { useState } from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container';
import * as R from 'ramda';
import storePersist from '../../../../../redux/storePersist';
import { useSelector } from 'react-redux';
import { selectListItems } from '../../../../../redux/library/selector';
export default function AddBusinessComponent ({handleInnerFormChange, businessDetails}: any) {
    const statesItems = storePersist?.get("states")?.current?.items;
    const countryItems = storePersist?.get("countries")?.current?.items;
    console.log(statesItems,countryItems,'bxxvvv')
    const libraryData = useSelector(selectListItems)
      const [
        stateValues,
        setStateValues
      ] = useState([])
      const onFilterToStates = (event: any) => {
        handleInnerFormChange(
           event,
          'CountryId'
        );
    
        if (event) {
            const filterStates: any = R.filter(
              (value: any) => value.CountryId === event,
              statesItems
            );
            if (filterStates.length) {
              setStateValues(filterStates);
            } else {
              setStateValues(statesItems);
            }
          } else {
            setStateValues([])
          }
      }
  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
      <InputContainer
    isRequired
    label="Business Name"
    name="Business Name"
    onValueChange={(event: any) => {
        handleInnerFormChange(
       event.target.value,
         'BusinessName'
      );
    }}
    type="text"
    value={businessDetails?.BusinessName}
/> 
<InputContainer
                 isRequired
                 label="Business Type"
                 labelField="Description"
                 list={libraryData?.result?.BusinessType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                          'BusinessTypeId'
                       );
                 }}
                 optionName="Choose BusinessType"
                 type="select"
                 value={businessDetails?.BusinessTypeId}
                 valueField="Value"
             />
 <InputContainer
                 isRequired
                 label="Industry Type"
                 labelField="Text"
                 list={libraryData?.result?.IndustryType}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                          'IndustryTypeId'
                       );
                 }}
                 optionName="Choose IndustryType"
                 type="select"
                 value={businessDetails?.IndustryTypeId}
                 valueField="Value"
             />
<InputContainer
    isRequired
    label="Currency Code"
    name="CurrencyCode"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'CurrencyCode'
           );
    }}
    type="text"
    value={businessDetails?.CurrencyCode}
/>
<InputContainer
    isRequired
    label="Email"
    name="Email"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Email'
           );
    }}
    type="text"
    value={businessDetails?.Email}
/>
<InputContainer
    isRequired
    label="Calling Code"
    name="CallingCode"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'CallingCode'
           );
    }}
    placeholder="Enter your Country Code"
    type="text"
    value={businessDetails?.CallingCode}
/>
<InputContainer
    isRequired
    label="Phone Number"
    name="PhoneNumber"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'PhoneNumber'
           );
    }}
    type="number"
    value={businessDetails?.PhoneNumber}
/>
<InputContainer
    icon
    isRequired
    label="Password"
    name="Password"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Password'
           );
    }}
    type="password"
    value={businessDetails?.Password}
/>
<InputContainer
    icon
    isRequired
    label="Confirm Password"
    name="Confirm Password"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'ConfirmPassword'
           );
    }}
    type="password"
    value={businessDetails?.ConfirmPassword}
/>
<InputContainer
                 label="Salutation"
                 labelField="Text"
                 list={libraryData?.result?.Salutation}
                 onValueChange={(event: any, newValue: any) => {
                    handleInnerFormChange(
                        event.target.value,
                          'Salutation'
                       );
                 }}
                 optionName="Choose Salutation"
                 type="select"
                 value={businessDetails?.Salutation}
                 valueField="Text"
             />
             <InputContainer
    isRequired
    label="First Name"
    name="FirstName"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'FirstName'
           );
    }}
    type="text"
    value={businessDetails?.FirstName}
/>
<InputContainer
    isRequired
    label="Last Name"
    name="LastName"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'LastName'
           );
    }}
    type="text"
    value={businessDetails?.LastName}
/>
<InputContainer
    isRequired
    label="Address1"
    name="Address1"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Address1'
           );
    }}
    type="text"
    value={businessDetails?.Address1}
/>
<InputContainer
    isRequired
    label="Address2"
    name="Address2"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'Address2'
           );
    }}
    type="text"
    value={businessDetails?.Address2}
/>
<InputContainer
    isRequired
    label="City"
    name="City"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'City'
           );
    }}
    type="text"
    value={businessDetails?.City}
/>
<InputContainer
                    isRequired
                    label="Country Name"
                    labelField="Name"
                    list={countryItems}
                    onValueChange={(event: any, newValue: any) => {
                      onFilterToStates(event.target.value);
                     
                    }}
                    optionName ="Choose country"
                    type="select"
                    value={businessDetails?.CountryId}
                    valueField="Id"
                />
                <InputContainer
                     label="State Name"
                     labelField="Name"
                     list={stateValues}
                     onValueChange={(event: any, newValue: any) => {
                        handleInnerFormChange(
                            event.target.value,
                              'StateProvinceId'
                           );
                     }}
 optionName ="Choose State"
                     type="select"
                     value={businessDetails?.StateProvinceId}
                     valueField="Id"
                 />
                 <InputContainer
    isRequired
    label="ZipPostal Code"
    name="ZipPostalCode"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event.target.value,
              'ZipPostalCode'
           );
    }}
    type="text"
    value={businessDetails?.ZipPostalCode}
/>
<InputContainer
    isRequired
    label="Terms Accepted"
    name="IsTermsAccepted"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
              'IsTermsAccepted'
           );
    }}
    type="checkbox"
    value={businessDetails?.IsTermsAccepted}
/>
<InputContainer
    isRequired
    label="NewsLetter Opted"
    name="IsNewsLetterOpted"
    onValueChange={(event: any) => {
        handleInnerFormChange(
            event,
              'IsNewsLetterOpted'
           );
    }}
    type="checkbox"
    value={businessDetails?.IsNewsLetterOpted}
/>
  </div>
  }
  expandedPanel="basicInfo"
  headerTitle="Basic Info"
/>
        </>
  )
}